export const PAGE_ROUTE = {
  HOME: 'HOME',
  TEASING: 'TEASING',
  MARKETPLACE: 'MARKETPLACE',
  TENANT_PROFILE: 'TENANT_PROFILE',
  TENANT_ANUNT: 'TENANT_ANUNT',
  PUBLIC_PROFILE: 'PUBLIC_PROFILE',
  LANDLORD_PROFILE: 'LANDLORD_PROFILE',
  DASHBOARD: 'DASHBOARD',
  DASHBOARD_PROFIL: 'DASHBOARD_PROFIL',
  DASHBOARD_ANUNT: 'DASHBOARD_ANUNT',
  DASHBOARD_APLICARI: 'DASHBOARD_APLICARI',
  DASHBOARD_APLICARI_ARCHIVE: 'DASHBOARD_APLICARI_ARCHIVE',
  DASHBOARD_PROFILE_SALVATE: 'DASHBOARD_PROFILE_SALVATE',
  DASHBOARD_SETARI: 'DASHBOARD_SETARI',
  PROPERTY_EDITOR: 'PROPERTY_EDITOR',
  ONBOARDING: 'ONBOARDING',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  RESET_PASSWORD: 'RESET_PASSWORD',
  RESET_PASSWORD_TOKEN: 'RESET_PASSWORD_TOKEN',
  CONTACT: 'CONTACT',
  TERMENI: 'TERMENI',
  CONFIDENTIALITATE: 'CONFIDENTIALITATE',
  REVIEW_SUBMISSION: 'REVIEW_SUBMISSION',
  CHANGELOG: 'CHANGELOG',
  PRICING: 'PRICING',
} as const

export type PageRoute = (typeof PAGE_ROUTE)[keyof typeof PAGE_ROUTE]

// Maps internal page routes to real browser URL paths so pages get their own
// shareable, SEO-friendly URLs instead of all living on "/".
export const ROUTE_PATH: Partial<Record<string, string>> = {
  [PAGE_ROUTE.HOME]: '/',
  [PAGE_ROUTE.TEASING]: '/',
  [PAGE_ROUTE.TERMENI]: '/termeni-si-conditii',
  [PAGE_ROUTE.CONFIDENTIALITATE]: '/politica-de-confidentialitate',
  [PAGE_ROUTE.CONTACT]: '/contact',
}

// Romanian, content-reflecting document titles for SEO and shareability.
export const ROUTE_TITLE: Partial<Record<string, string>> = {
  [PAGE_ROUTE.HOME]: 'Izio — Lasă chiria să te găsească | Înscrieri Beta',
  [PAGE_ROUTE.TEASING]: 'Izio — Lasă chiria să te găsească | Înscrieri Beta',
  [PAGE_ROUTE.TERMENI]: 'Termeni și Condiții | Izio',
  [PAGE_ROUTE.CONFIDENTIALITATE]: 'Politica de Confidențialitate | Izio',
  [PAGE_ROUTE.CONTACT]: 'Contact | Izio',
}

const DEFAULT_TITLE = 'Izio — Lasă chiria să te găsească'

export function pathForRoute(route: string): string {
  return ROUTE_PATH[route] ?? '/'
}

export function routeForPath(pathname: string): string | null {
  const clean = pathname.replace(/\/+$/, '') || '/'
  const match = Object.entries(ROUTE_PATH).find(
    ([route, path]) =>
      (path === '/' ? clean === '/' : clean === path) &&
      route !== PAGE_ROUTE.TEASING, // prefer HOME for "/"
  )
  return match ? match[0] : null
}

export function titleForRoute(route: string): string {
  return ROUTE_TITLE[route] ?? DEFAULT_TITLE
}
